import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { createQuiz, editQuiz } from "../../../api/endpoints/QuizEndpoints";
import { Quiz } from "../../../models/Quiz";

export default function useCreateOrEditQuiz(lessonId: string) {
  return useMutation<
    { id: number },
    AxiosError,
    { quiz: Quiz; operation: "create" | "edit" }
  >({
    mutationKey: ["create-or-edit-quiz", lessonId],
    mutationFn: ({ quiz, operation }) =>
      operation === "create" ? createQuiz(quiz) : editQuiz(quiz),
  });
}
